/**
 * Role-based access control utilities for the Perfect Truck module.
 *
 * Read-only status is driven entirely by the API's `readOnly` flag returned in
 * the `moduleAccess` array from GET /common/location-with-access.
 * Read `state.appData.moduleAccess`, find the "Perfect Truck" entry, and pass
 * its `readOnly` field into these functions.
 */


/** Returns true when the user is a Team Lead (roleId 9). */
export const isTeamLead = (roleId?: number): boolean => roleId === 9;


/** Returns true when the user is allowed to create/submit a certification. */
export const canCreateCertification = (isReadOnly: boolean): boolean => !isReadOnly;

/** Returns true when the user is allowed to create a standalone Check Record. */
export const canCreateCheck = (_roleId?: number): boolean => true;

/** Returns true when the user is allowed to submit a checker verification response. */
export const canSubmitCheckerVerification = (isReadOnly: boolean): boolean => !isReadOnly;

